export var debugInfoSectionPropsILeanProductTileAdapter = function(productTile) {
    var _productTile_product, _productTile_product1;
    return {
        productToken: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
        promotedBy: (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.promoted_by,
        debugInfo: productTile.retrieval_and_ranking_debug_info
    };
};
